import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { I18nProvider } from "./i18n";
import { ThemeProvider } from "./theme/ThemeProvider";
import Onboarding from "./pages/Onboarding";
import BaoStudio from "./pages/BaoStudio";
import Bao3D from "./pages/Bao3D";
import VRVillage from "./pages/patient/VRVillage";
import Album from "./pages/patient/Album";
import SavannaLevel from "./pages/patient/SavannaLevel";
import ExerciseCatalog, { ExerciseCatalogBody } from "./pages/exercises/ExerciseCatalog";
import ExercisePlayer from "./pages/exercises/ExercisePlayer";
import Home from "./pages/Home";
import PatientEntry from "./pages/patient/PatientEntry";
import Calibration from "./pages/patient/Calibration";
import WorldMap from "./pages/patient/WorldMap";
import VillageLevel from "./pages/patient/VillageLevel";
import SessionEnd from "./pages/patient/SessionEnd";
import CareLayout from "./pages/care/CareLayout";
import Overview from "./pages/care/Overview";
import Patients from "./pages/care/Patients";
import PatientDetail from "./pages/care/PatientDetail";
import SessionConfig from "./pages/care/SessionConfig";
import Assessments from "./pages/care/Assessments";
import Sessions from "./pages/care/Sessions";
import SessionReport from "./pages/care/SessionReport";
import Progress from "./pages/care/Progress";
import Missions from "./pages/care/Missions";
import Settings from "./pages/care/Settings";

function App() {
  return (
    <ThemeProvider>
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/bao" element={<BaoStudio />} />
          <Route path="/bao/3d" element={<Bao3D />} />
          <Route path="/exercises" element={<ExerciseCatalog />} />
          <Route path="/exercises/:id" element={<ExercisePlayer />} />
          <Route path="/patient" element={<PatientEntry />} />
          <Route path="/patient/calibration" element={<Calibration />} />
          <Route path="/patient/map" element={<WorldMap />} />
          <Route path="/patient/village" element={<VillageLevel />} />
          <Route path="/patient/savanna" element={<SavannaLevel key="savanna" />} />
          <Route path="/patient/river" element={<SavannaLevel key="river" levelKey="river" />} />
          <Route path="/patient/vr" element={<VRVillage />} />
          <Route path="/patient/album" element={<Album />} />
          <Route path="/patient/bridge" element={<SavannaLevel key="bridge" levelKey="bridge" />} />
          <Route path="/patient/forest" element={<SavannaLevel key="forest" levelKey="forest" />} />
          <Route path="/patient/end" element={<SessionEnd />} />
          <Route path="/care" element={<CareLayout />}>
            <Route index element={<Overview />} />
            <Route path="patients" element={<Patients />} />
            <Route path="patients/:pid" element={<PatientDetail />} />
            <Route path="patients/:pid/session/new" element={<SessionConfig />} />
            <Route path="assessments" element={<Assessments />} />
            <Route path="sessions" element={<Sessions />} />
            <Route path="sessions/:sid/report" element={<SessionReport />} />
            <Route path="progress" element={<Progress />} />
            <Route path="missions" element={<Missions />} />
            <Route path="settings" element={<Settings />} />
            <Route path="exercises" element={<ExerciseCatalogBody />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors duration={2200} />
    </I18nProvider>
    </ThemeProvider>
  );
}

export default App;
